import script from "./coloredLeftBorder.vue?vue&type=script&setup=true&lang=ts"
export * from "./coloredLeftBorder.vue?vue&type=script&setup=true&lang=ts"

import "./coloredLeftBorder.vue?vue&type=style&index=0&id=124abc6e&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-124abc6e"]])

export default __exports__